// extracted by mini-css-extract-plugin
export default {"content":"styles__content--2Uynv"};